module.exports = __webpack_public_path__ + "479197d368e8a55fd4ba4f09ea4aa168.png";